import { RT_API_USAGE } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  entries: [],
  masks: {
    ytdMatched: [],
    mtdMatched: [],
    btdMatched: [],
    tdyMatched: [],
    '7dMatched': [],
    '30dMatched': [],
    '1yMatched': [],
    '6cMatched': [],
    ytdUnmatched: [],
    mtdUnmatched: [],
    btdUnmatched: [],
    tdyUnmatched: [],
    '7dUnmatched': [],
    '30dUnmatched': [],
    '1yUnmatched': [],
    '6cUnmatched': [],
    ytdTotal: [],
    mtdTotal: [],
    btdTotal: [],
    tdyTotal: [],
    '7dTotal': [],
    '30dTotal': [],
    '1yTotal': [],
    '6cTotal': [],
  },

  fetchEntriesStatus: null,
  fetchEntriesError: null,
  ytdCount: null,
  mtdCount: null,
  tdyCount: null,
  countMatches: false,
  generateStatsStatus: null,
  generateStatsError: null,
  config: null,
  fetchConfigStatus: null,
  fetchConfigError: null,
  configList: [],
  fetchConfigListStatus: null,
  fetchConfigListError: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RT_API_USAGE.UNSET:
      return {
        ...state,
        [action.payload]: INITIAL_STATE[action.payload],
      };
    case RT_API_USAGE.FETCH_CONFIG_LIST:
      return {
        ...state,
        fetchConfigListStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_USAGE.FETCH_CONFIG_LIST_FAILURE:
      return {
        ...state,
        fetchConfigListError: action.payload,
        fetchConfigListStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_USAGE.FETCH_CONFIG_LIST_SUCCEEDED:
      return {
        ...state,
        configList: action.payload,
        fetchConfigListStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_USAGE.FETCH_CONFIG:
      return {
        ...state,
        fetchConfigStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_USAGE.FETCH_CONFIG_FAILURE:
      return {
        ...state,
        fetchConfigError: action.payload,
        fetchConfigStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_USAGE.FETCH_CONFIG_SUCCEEDED:
      return {
        ...state,
        config: action.payload,
        fetchConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_USAGE.FETCH_ENTRIES:
      return {
        ...state,
        fetchEntriesStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_USAGE.FETCH_ENTRIES_FAILED:
      return {
        ...state,
        fetchEntriesError: action.payload,
        fetchEntriesStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_USAGE.FETCH_ENTRIES_SUCCEEDED:
      return {
        ...state,
        ...action.payload,
        fetchEntriesStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_USAGE.GENERATE_STATS:
      return {
        ...state,
        generateStatsStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_USAGE.GENERATE_STATS_FAILED:
      return {
        ...state,
        generateStatsError: action.payload,
        generateStatsStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_USAGE.GENERATE_STATS_SUCCEEDED:
      return {
        ...state,
        ...action.payload,
        generateStatsStatus: CONSTANTS.API.SUCCEEDED,
      };
    default:
      return state;
  }
};
